import { Route, Router, RouteSectionProps, useLocation } from '@solidjs/router'
import Footer from 'layout/footer'
import Navbar from 'layout/navbar'
import { createRenderEffect, lazy, on, onCleanup } from 'solid-js'
import { render, Show } from 'solid-js/web'

import { Alerts, Popup } from 'components'
import Lenis from 'lenis'
import Corps from 'pages/panel/corps'
import Extentions from 'pages/panel/extentions/'
import ExtentionRequests from 'pages/panel/extentions/requests'
import ExtentionSubmitteds from 'pages/panel/extentions/submitteds'
import Insurances from 'pages/panel/insurances'
import Overview from 'pages/panel/overview'
import Profile from 'pages/panel/profile'
import Requests from 'pages/panel/requests'
import Users from 'pages/panel/users'
import Corp from 'pages/panel/users/corp'
import CorpExtentions from 'pages/panel/users/corp/extentions'
import CorpInsurances from 'pages/panel/users/corp/insurnaces'
import CorpUsers from 'pages/panel/users/corp/users'
import './style/base.scss'
import './style/config.scss'

const Home = lazy(() => import('./pages/home'))
const Login = lazy(() => import('./pages/login'))
const Panel = lazy(() => import('./pages/panel'))

const Error404 = lazy(() => import('./pages/panel/404'))
const Error403 = lazy(() => import('./pages/panel/403'))

const Root = () => {
    return (
        <>
            <Router base='/' root={Rootlayout}>
                <Route path={'/'} component={Home}></Route>

                <Route path={'/login'} component={Login} />

                <DashRoutes />

                {/* <Route path='*' component={Page404} /> */}
            </Router>

            <Alerts />
            <Popup />
        </>
    )
}

const DashRoutes = () => (
    <Route path='/panel' component={Panel}>
        <Route path='/' component={Overview} />
        <Route path='/overview' component={Overview} />

        <Route path='/corporations/' component={Corps}></Route>
        <Route path='/corporations/corp/:id' component={Corp}>
            <Route path='/' component={CorpUsers}></Route>
            <Route path='/insurances' component={CorpInsurances}></Route>
            <Route path='/corrections' component={CorpExtentions}></Route>
        </Route>

        <Route path='/insurances' component={Insurances} />
        <Route path='/extentions/'>
            <Route path='/' component={Extentions}></Route>
            <Route path='/requests/' component={ExtentionRequests}></Route>
            <Route path='/submitteds/' component={ExtentionSubmitteds}></Route>

            <Route path='*' component={undefined} />
        </Route>
        <Route path='/profile' component={Profile} />
        <Route path='/users' component={Users} />
        <Route path='/coop-requests' component={Requests} />

        <Route path='/403' component={Error403} />
        <Route path='*' component={Error404} />
    </Route>
)

export let lenis: Lenis | undefined = undefined

const HIDE_URLS = ['/login', '/panel']
const Rootlayout = (P: RouteSectionProps) => {
    const loc = useLocation()

    const initLenis = () => {
        if (lenis) return

        lenis = new Lenis({
            smoothWheel: true,
            duration: 1.3, // Extend the duration of the scroll (higher = longer inertia)
            easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // Custom easing function for inertia effect
        })

        function raf(time: any) {
            lenis?.raf(time)
            requestAnimationFrame(raf)
        }

        requestAnimationFrame(raf)
    }

    createRenderEffect(
        on(
            () => loc.pathname,
            () => {
                if (!lenis) return initLenis()

                lenis.stop()

                lenis.scrollTo?.(0, {
                    immediate: true,
                })

                requestAnimationFrame(() => lenis!.start())
            }
        )
    )

    onCleanup(() => {
        try {
            lenis?.destroy()
        } catch {}
        lenis = undefined
    })

    return (
        <>
            <Show when={!HIDE_URLS.some(l => loc.pathname.startsWith(l))}>
                <Navbar />
            </Show>
            {P.children}
            <Show when={!HIDE_URLS.some(l => loc.pathname.startsWith(l))}>
                <Footer />
            </Show>
        </>
    )
}

render(() => <Root />, document.getElementById('root')!)
